import { render, staticRenderFns } from "./spot-video-dialog.vue?vue&type=template&id=20dfd54a&scoped=true"
import script from "./spot-video-dialog.vue?vue&type=script&lang=js"
export * from "./spot-video-dialog.vue?vue&type=script&lang=js"
import style0 from "./spot-video-dialog.vue?vue&type=style&index=0&id=20dfd54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfd54a",
  null
  
)

export default component.exports